import asm6502 from "refractor/asm6502";
export default asm6502;